import { render } from "./WidgetDescription.vue?vue&type=template&id=42b3ae92"
import script from "./WidgetDescription.vue?vue&type=script&lang=js"
export * from "./WidgetDescription.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__